import { PermissionGroupFilterInput } from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils
} from "../../../utils/filters";
import {
  PermissionGroupListUrlFilters,
  PermissionGroupListUrlFiltersEnum,
  PermissionGroupListUrlQueryParams
} from "../../urls";

export const PERMISSION_FILTERS_KEY = "permissionGroupsFilters";

export function getFilterVariables(
  params: PermissionGroupListUrlFilters
): PermissionGroupFilterInput {
  return {
    search: params.query
  };
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<PermissionGroupListUrlFilters>(PERMISSION_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  PermissionGroupListUrlQueryParams,
  PermissionGroupListUrlFilters
>(PermissionGroupListUrlFiltersEnum);
